import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import UserContext from '../context/UserContext';

const PasswordResetForm = ({ apiEndpoint }) => {
  const param = useParams();
  const [searchParams] = useSearchParams();
  const [allowed, setAllowed] = useState(false);
  const [pass, setPass] = useState('');
  const [confirm, setConfirm] = useState('');
  const nav = useNavigate();
const {apiURL} = useContext(UserContext)
  const [status, setStatus] = useState({
    error: '',
    success: '',
    loading: false,
  });

  // Function to check if the ttr timestamp has passed
  const hasTimePassed = (ttr) => {
    if (!ttr) return true; // No ttr provided, consider invalid
    const ttrTime = parseInt(ttr, 10); // Convert to number
    if (isNaN(ttrTime)) return true; // Invalid ttr, consider expired
    const currentTime = Date.now(); // Current time in milliseconds
    console.log(ttrTime)
    return ttrTime < currentTime; // True if ttr is in the past
  };

  useEffect(() => {
    const checkReset = async () => {
      const ttr = searchParams.get('ttr');
      if (hasTimePassed(ttr)) {
        toast.warning('This reset link has expired.');
          setAllowed(false)
        return;
      }

      try {
        const hh = {
          token: searchParams.get('token'),
          email: searchParams.get('email'),
        };
        const resp = await axios.post(`${apiURL}/users/checkreset`, hh);
        if (resp.data.status !== 200) {
  console.log(resp.data)
        }
         setAllowed(true)
       // setAllowed(true);
      } catch (err) {
         toast.warning(err.message);
       }
    };
    checkReset();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'password') setPass(value);
    if (name === 'confirmPassword') setConfirm(value);
    setStatus({ ...status, error: '', success: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ ...status, error: '', success: '', loading: true });

    if (pass.length < 8) {
      setStatus({ ...status, error: 'Password must be at least 8 characters long.', loading: false });
      return;
    }
    if (pass !== confirm) {
      setStatus({ ...status, error: 'Passwords do not match.', loading: false });
      return;
    }

    try {
      const hh = {
        id: searchParams.get('otp'),
        pass,
      };
       const resp = await axios.post(`${apiURL}/users/forgotreset`, hh)
       .then(res => {
        if(res.data.status === 200){
 toast.success('Password reset successfully!');
      nav('/');
        }
       })
       .catch(err => console.log(err))

       
      // setStatus({
      //   error: '',
      //   success: 'Password reset successfully!',
      //   loading: false,
      // });
     
    } catch (err) {
      console.error(err);
      setStatus({
        error: 'Failed to reset password. Please try again.',
        success: '',
        loading: false,
      });
      toast.warning('Failed to reset password.');
    }
  };

  if (!allowed) {
    return (
      <div>
        This page is invalid or has expired. Let’s get you back on track. <Link to="/login">Go to Login</Link>
      </div>
    );
  }

  return (
    <div className="h-[80vh] flex justify-center items-center">
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">Reset Your Password</h2>
        <form onSubmit={handleSubmit} className="space-y-6" aria-live="polite">
          <div className="text-left">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
              New Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={pass}
              onChange={handleChange}
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter new password"
              required
              aria-describedby={status.error ? 'password-error' : null}
            />
          </div>
          <div className="text-left">
            <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
              Confirm Password
            </label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={confirm}
              onChange={handleChange}
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Confirm new password"
              required
              aria-describedby={status.error ? 'password-error' : null}
            />
          </div>
          {status.error && (
            <p id="password-error" className="text-red-500 text-sm">{status.error}</p>
          )}
          {status.success && <p className="text-green-500 text-sm">{status.success}</p>}
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:bg-blue-400"
            disabled={status.loading}
          >
            {status.loading ? 'Processing...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordResetForm;